import React, { useEffect, useState } from 'react';
import Dummydiv from '../../assets/dummydiv.png';
import { getImageByID } from '../../utility/indexedDBHelper';
import { addEmpIDToSession } from '../../utility/addEmpIDToSession';
import { useNavigate } from 'react-router';

const GetImage = ({ imgID, redirect = true, width = "60px", height = "60px" ,isborderradius=false}) => {
  const [imgSrc, setImgSrc] = useState(null);

  const navigate=useNavigate()
  useEffect(() => {
    let intervalId;
      let objectUrl;
      const loadImageFromIndexedDB = async() => {
      const image = await getImageByID(imgID);
    if (image?.imageUrl && image.imageUrl !== 'string') {
       objectUrl = URL.createObjectURL(image.imageUrl);
   
          setImgSrc(objectUrl);
      clearInterval(intervalId);
    } else {
      setImgSrc(null);
    }
     
    };
    if (imgID) {
      // console.log("calledddd data")
       addEmpIDToSession(imgID);
       loadImageFromIndexedDB();
      intervalId = setInterval(loadImageFromIndexedDB, 1000);
    }
  
    const handleImageUpdate = (event) => {
      // console.log(event,"event")
        if (event?.detail?.imgID) {
     if (String(event?.detail?.imgID) == String(imgID)) {
         loadImageFromIndexedDB();
      }
  }  
    };

    window.addEventListener("userImageUpdated", handleImageUpdate);
    return () => {
      clearInterval(intervalId);
      if (objectUrl) URL.revokeObjectURL(objectUrl);
      window.removeEventListener("userImageUpdated", handleImageUpdate);
    };
  }, [imgID]);

  const handleClick = () => {
    if (redirect && imgID) {
      navigate(`/profile?${btoa(`id=${imgID}&IsShowArrow=true`)}`)
    }
  };

  return (
    <div
      key={imgID}
      onClick={(e)=>{
        e.stopPropagation()
        handleClick()
      }
      }
      style={{
        backgroundImage: `url(${imgSrc || Dummydiv})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        borderRadius: isborderradius ? "10px": '50%',
        width,
        height,
        objectFit:"cover",
        cursor: 'pointer',
        // pointerEvents:"none"
      }}
    />
  );
};

export default GetImage;